
import head from '../mixins/MetaHead'
import { getUnitPageInfo } from '~/fc/Dal/PageInfoRepo'
import { UnitIndexMeta } from '~/fc/Constants/meta'
import { lazyLoadComponentIfVisible } from '~/fc/lazy-load-component';
import Skeleton from '~/components/Skeleton.vue';

export default {
    name: 'UnitConverter',
    components: {
        UnitIndex: () => import(/* webpackChunkName: "UnitIndex" */ '../layouts/ConverterTemplates/UnitIndex'),
        Alert: () => import(/* webpackChunkName: "Alert" */ '../components/ui/Alert'),
        AdsSide: () => import(/* webpackChunkName: "AdsSide" */ '../layouts/partials/ads/AdsSide'),
        AdInPage: () => import(/* webpackChunkName: "AdInPage" */ '../layouts/partials/ads/AdInPage'),
        ContentCard: () => import(/* webpackChunkName: "ContentCard" */ '../components/content/ContentCard'),
        ContentCardHTML: () => import(/* webpackChunkName: "ContentCardHTML" */ '../components/content/ContentCardHTML'),
        SecurityAndCompliance: () => import(/* webpackChunkName: "SecurityAndCompliance" */ "~/components/ui/SecurityAndCompliance"),
        TryFree: lazyLoadComponentIfVisible({componentLoader: () => import(/* webpackChunkName: "TryFree" */ '../layouts/partials/page/TryFree'), loadingComponent: Skeleton }),
    },
    mixins: [head],

    async asyncData(ctx) {
        ctx.store.commit('advancedSetting/clearOptions')
        const id = ctx.params.id ? ctx.params.id : 'unit-converter'
        const info = await getUnitPageInfo(ctx)

        return {
            info,
            active: info.active,
            type: info.type,
            title: info.title,
            desc: info.desc || info.meta_description,
            header_h1: info.header_h1,
            subtext_h1: info.subtext_h1,
            currentUrl: `/${id}`
        }
    },
    data() {
        return {
            info: {},
            active: null,
            type: null,
            uid: 1
        }
    },
    created() {
        this.title = this.$t('converter_unit_converter')

        this.setData({ info: this.info, type: this.type })
        this.$store.commit('updateBreadcrumbs', [{
            url: this.localePath('/unit-converter'), label: this.$t('unit_converter')
        }])
    },
    methods: {
        setData({ info, type }) {
            const metaData = UnitIndexMeta(this)
            this.info = { ...info, ...metaData }
            this.type = type
            this.uid++
        }
    }
}
